import { useRef, useEffect } from 'react';

var usePrevious = function usePrevious(value) {
  var ref = useRef();
  useEffect(function () {
    ref.current = value;
  }, [value]);
  return ref.current;
};
var usePrevious$1 = usePrevious;

export { usePrevious$1 as default };
//# sourceMappingURL=usePrevious.js.map
